
angular.module('bmsApp.employeeGroup', [])

	.config([
		'$stateProvider',
		'$urlRouterProvider',
		'BMSPermission', function config(
			$stateProvider,
			$urlRouterProvider,
			BMSPermission
		) {

			$stateProvider

				.state('main.employee.index.groups', {
					url: '/groups',
					views: {
						'content@main.employee': {
							templateUrl: "ng/employee/employeeGroups/templates/EmployeeGroupIndex.html",
							controller: 'EmployeeGroupIndexCtrl',
							controllerAs: 'GroupIndex',
						}
					},
					ncyBreadcrumb: {label: 'Manage Groups'}
				})

				.state('main.employee.index.groups.create', {
					url: '/create',
					views: {
						'content@main.employee': {
							templateUrl: "ng/employee/employeeGroups/templates/EmployeeGroupSave.html",
							controller: 'EmployeeGroupSaveCtrl',
							controllerAs: 'GroupSave',
						}
					},
					ncyBreadcrumb: {label: 'Create Group'}
				})

				.state('main.employee.index.groups.edit', {
					url: '/edit/{groupId}',
					views: {
						'content@main.employee': {
							templateUrl: "ng/employee/employeeGroups/templates/EmployeeGroupSave.html",
							controller: 'EmployeeGroupSaveCtrl',
							controllerAs: 'GroupSave',
						}
					},
					ncyBreadcrumb: {label: 'Edit Group'}
				})

			;

		}]);
